<!-- // src/components/DrawCountdown.svelte -->
<script>
	import { onMount } from "svelte";
	import { browser } from "$app/environment";
	import { daysRemaining, untilLiveDraw, untilThursdayDraw } from "$lib/helpers";
	import Carousel from 'svelte-carousel'
	import { isAppUser } from "$stores/isAppUser";

	let nextDraw = '';
	let daysUntilNextDraw;
	let hours;

	let carousel; // for calling methods of the carousel instance
	
	function calculateNextDraw() {
		if (!browser) return;

		const monday = untilLiveDraw();
		const daysUntilMonday = daysRemaining(monday);
		const thursday = untilThursdayDraw();
		const daysUntilThursday = daysRemaining(thursday);

		daysUntilNextDraw = Math.min(daysUntilMonday, daysUntilThursday);

		let objDate = new Date();
		hours = objDate.getHours();

		if (daysUntilMonday < daysUntilThursday) {
			nextDraw = "Monday";
		} else {
			nextDraw = "Thursday";
		}
	}

	onMount(() => {
		if (!browser) return;
		calculateNextDraw();
	});
</script>

{#if browser}
  <Carousel
    bind:this={carousel}
	autoplayDuration={0}
	duration={9000}
	autoplay
	timingFunction="linear"
	dots={false}
	arrows={false}
	swiping={false}
  >
    <div>
		{#if nextDraw.length}
		<p>

			{#if daysUntilNextDraw === 0}
				{#if hours >= 20}
					Live draw in
					<a href="https://www.facebook.com/hotdrawuk/?locale=en_GB">
						{nextDraw === "Monday" ? "2 Days" : "3 Days"}
					</a>
				{:else}
					Live draw 
					<a href="https://www.facebook.com/hotdrawuk/?locale=en_GB">
						Tonight at 
						7:30pm!
					</a>
				{/if}
			{:else}
				{#if daysUntilNextDraw === 1}
					Live draw Tomorrow at <span>7:30pm</span>
				{:else}
					Live draw in <span>{daysUntilNextDraw} {daysUntilNextDraw === 1 ? 'Day' : 'Days'}</span>
				{/if}
			{/if}
			</p>

		{/if}
	</div>
	{#if !$isAppUser}
	<div><p><a href="/subscribe">Subscribe</a> & Save</p></div>
	{/if}
    <div><p>No Extensions <span>Ever</span> </p></div>
    <div><p><span>Guaranteed</span> Live Draws </p></div>
    <div><p>Thousands of <span>Winners</span>  </p></div>
  </Carousel>
{/if}


<style lang="scss">
	p {
		font-size: 1.05em;
		padding: 0 20px;
		font-weight: 600;
		text-align: center;
		text-transform: uppercase;
		white-space: nowrap;
		margin: 8px 0;
		span, a {
			color: #fe1100;
			// color: #E66C2C; // halloween
		}
		a {
			text-decoration: underline;
		}
	}

</style>
